export const BACKSPACE_KEY = 8;
export const KEY_ENTER = 13;
export const ESC_KEY = 27;
export const LEFT_KEY = 37;
export const RIGHT_KEY = 39;
export const NUMERIC_ZERO_KEY = 48;
export const NUMERIC_NINE_KEY = 57;

